import React from 'react';
import {Collapse} from '@mui/material';
import Box from '@mui/material/Box';
import {Card, FlexBox, Text} from 'components';
import {DataFormV1} from 'schema';
import {DataFormCompareLayout} from 'schema/form/components/DataFormCompareLayout';
import type {CompareEntitiesFormsProps} from '../types';
import {useCollapseContext} from '../context/CollapseContext';
import {useCompareEntitiesContext} from '../context/CompareEntitiesContext';

export const CompareEntitiesForms: React.FC<CompareEntitiesFormsProps> = ({
  formConfiguration,
  targetHeader,
  sourceHeader,
  additionalComparisons,
}) => {
  const {target, source, onChange} = useCompareEntitiesContext();
  const {isCollapsed} = useCollapseContext();

  return (
    <>
      <Collapse in={isCollapsed}>
        <FlexBox horizontal flex={1} mb={4}>
          <DataFormCompareLayout
            renderCurrent={() => (
              <Card mode={'light'} color={'primary'}>
                {targetHeader}
                <DataFormV1
                  id={'targetDataForm'}
                  schema={target.schema}
                  originalData={target.data}
                  data={target.data ?? {}}
                  configuration={formConfiguration}
                  mode="edit"
                  relatedData={{}}
                  showErrors={true}
                  onDataChanged={onChange}
                />
              </Card>
            )}
            renderProposed={() => (
              <Card mode={'light'} color={'primary'}>
                {sourceHeader}
                {source ? (
                  <DataFormV1
                    id={'sourceDataForm'}
                    schema={source.schema}
                    data={source.data ?? {}}
                    configuration={formConfiguration}
                    mode="read-only"
                    relatedData={{}}
                  />
                ) : (
                  <Box
                    sx={{
                      mt: 2,
                      ml: 2,
                    }}>
                    <Text variant={'body2'}>Fant ingen forskjeller</Text>
                  </Box>
                )}
              </Card>
            )}
          />
        </FlexBox>
      </Collapse>
      {additionalComparisons?.map((comparison, i) => (
        <FlexBox horizontal flex={1} mb={4} key={`additionalComparison_${i}`}>
          <DataFormCompareLayout
            renderCurrent={() => (
              <Card mode={'light'} color={'primary'}>
                <DataFormV1
                  id={`additionalComparisons_target_${i}`}
                  schema={comparison.target.schema}
                  data={comparison.target.data ?? {}}
                  configuration={formConfiguration}
                  mode="read-only"
                  relatedData={{}}
                />
              </Card>
            )}
            renderProposed={() => (
              <Card mode={'light'} color={'primary'}>
                {comparison.source ? (
                  <DataFormV1
                    id={`additionalComparisons_source_${i}`}
                    schema={comparison.source.schema}
                    data={comparison.source.data ?? {}}
                    configuration={formConfiguration}
                    mode="read-only"
                    relatedData={{}}
                  />
                ) : (
                  <Box
                    sx={{
                      mt: 2,
                      ml: 2,
                    }}>
                    <Text variant={'body2'}>Fant ingen forskjeller</Text>
                  </Box>
                )}
              </Card>
            )}
          />
        </FlexBox>
      ))}
    </>
  );
};
